import React from "react";
import SkillPill from "./SkillPill";

const SkillFlipCard = ({ item, index, relatedSkills }) => {
    const formattedIndex = String(index + 1).padStart(2, '0');

    return (
        <div className={`reveal reveal-delay-${(index % 4) + 1} group h-[420px] [perspective:1200px]`}>
            <div className="relative w-full h-full transition-all duration-[800ms] [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)] ease-[cubic-bezier(0.4,0,0.2,1)]">

                {/* --- FRONT SIDE: Refined Aesthetic --- */}
                <div className="absolute inset-0 [backface-visibility:hidden] p-8 rounded-[2.5rem] bg-white dark:bg-surface-dark border border-gray-100 dark:border-gray-800 shadow-soft group-hover:shadow-hover flex flex-col items-start text-left overflow-hidden transition-all duration-500">

                    {/* Decorative Glass Background Element */}
                    <div className="absolute -top-12 -right-12 size-40 bg-primary/5 rounded-full blur-3xl group-hover:bg-primary/10 transition-colors duration-700"></div>

                    {/* Background Indexing */}
                    <span className="absolute top-6 right-8 text-6xl font-black text-gray-50 dark:text-gray-800/10 font-display select-none transition-transform duration-500 group-hover:scale-110">
                        {formattedIndex}
                    </span>

                    {/* Icon Container with subtle "floating" effect */}
                    <div className="size-16 rounded-2xl bg-gradient-to-br from-primary/10 to-transparent text-primary flex items-center justify-center mb-10 ring-1 ring-primary/20 shadow-sm group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                        <span className="material-symbols-outlined text-4xl">
                            {item.id === 1 ? 'terminal' : item.id === 2 ? 'psychology' : item.id === 3 ? 'hub' : 'palette'}
                        </span>
                    </div>

                    <h3 className="text-2xl font-bold text-[#0d121b] dark:text-white font-display mb-4 tracking-tight">
                        {item.category}
                    </h3>

                    <p className="text-gray-500 dark:text-gray-400 text-[15px] leading-relaxed mb-6 font-medium">
                        {item.description}
                    </p>

                    <div className="mt-auto flex items-center gap-3 text-primary font-bold text-[11px] uppercase tracking-[0.2em] group-hover:gap-5 transition-all duration-500">
                        <span className="animate-pulse">Explore Skills</span>
                        <span className="material-symbols-outlined text-sm">arrow_forward</span>
                    </div>
                </div>

                {/* --- BACK SIDE: High-Contrast Expertise --- */}
                <div className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] p-8 rounded-[2.5rem] bg-gray-50 dark:bg-[#0a0f18] border-2 border-primary/20 shadow-2xl flex flex-col overflow-hidden">

                    {/* Header with gradient underline */}
                    <div className="mb-6">
                        <h3 className="text-xs font-black uppercase tracking-[0.2em] text-primary mb-2">
                            {item.category} Expertise
                        </h3>
                        <div className="h-1 w-12 bg-gradient-to-r from-primary to-transparent rounded-full"></div>
                    </div>

                    <div className="flex flex-col gap-1 overflow-y-auto pr-2 custom-scrollbar flex-grow">
                        {relatedSkills.length > 0 ? (
                            relatedSkills
                                .sort((a, b) => b.level - a.level)
                                .map(skill => <SkillPill key={skill.id} skill={skill} />)
                        ) : (
                            <div className="flex flex-col items-center justify-center h-full opacity-40">
                                <span className="material-symbols-outlined text-4xl mb-2">inventory_2</span>
                                <p className="text-xs italic text-center">Awaiting data...</p>
                            </div>
                        )}
                    </div>

                    {/* Exit Prompt */}
                    <div className="mt-4 pt-4 border-t border-gray-200 dark:border-white/5 flex justify-center">
                        <span className="flex items-center gap-2 text-[9px] text-gray-400 dark:text-gray-500 uppercase tracking-widest font-black">
                            <span className="material-symbols-outlined text-[12px] rotate-180">arrow_forward</span>
                            Hover out to return
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkillFlipCard;